'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'browser';
var width = 512;
var height = 512;
var aliases = [128468];
var unicode = 'f37e';
var svgPathData = ['M16 192l480 0 0 192c0 26.5-21.5 48-48 48L64 432c-26.5 0-48-21.5-48-48l0-192z', 'M144 80l0 96 352 0 0-48c0-26.5-21.5-48-48-48L144 80zm-16 0L64 80c-26.5 0-48 21.5-48 48l0 48 112 0 0-96zM16 192l0 192c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-192-480 0zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrowser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;